import request from '../../shared/request'

export function getEmployeesList() {
  return request('/employee')
}

export function createEmployee(payload) {
  return request(`/employee`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function editEmployee(payload) {
  return request(`/employee/${payload.employeeId}`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteEmployee(payload) {
  return request(`/employee/${payload.employeeId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function editEmployeeStatus(payload) {
  return request(`/employee/${payload.employeeId}/status`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/employee/${payload.employeeId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(employeeId) {
  return request(`/employee/${employeeId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/employee/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/employee/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// notes
export function fetchEmployeeNote(payload) {
  return request(`/employee/${payload.employeeId}/notes`)
}

export function createEmployeeNote(payload) {
  return request(`/employee/${payload.employeeId}/notes`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editEmployeeNote(payload) {
  return request(`/employee/${payload.noteId}/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteEmployeeNote(payload) {
  return request(`/employee/${payload.noteId}/notes`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

// followUps
export function fetchEmployeeFollowUp(payload) {
  return request(`/employee/${payload.employeeId}/followups`)
}

export function createEmployeeFollowUp(payload) {
  return request(`/employee/${payload.employeeId}/followups`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editEmployeeFollowUp(payload) {
  return request(`/employee/${payload.followUpId}/followups`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteEmployeeFollowUp(payload) {
  return request(`/employee/${payload.followUpId}/followups`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/employee.js